
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Loader } from '../loader.model';

@Component({
  selector: 'loader-progress-bar',
  standalone: true,
  imports: [],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderProgressBarComponent {
  @Input() loader?: Loader;
}
